'use client';

import { Text } from '@savvy-kit/foundations/text';
import { cn } from '@savvy-kit/lib/utils';
import { Stepper } from '@savvy-kit/patterns/stepper';

import type { StepData } from '@savvy-kit/patterns/stepper';

type AdvisorContact = {
  readonly name: string;
  readonly email: string;
};

type TransferTimelineCardProps = {
  readonly title?: string;
  readonly steps: StepData[];
  readonly activeStep: number;
  readonly advisor?: AdvisorContact;
  readonly className?: string;
  readonly showStepIcons?: boolean;
  readonly titleVariant?: 'h4' | 'subtitle-lg';
};

export function TransferTimelineCard({
  title = 'Transfer timeline',
  steps,
  activeStep,
  advisor,
  className,
  showStepIcons = false,
  titleVariant = 'subtitle-lg',
}: TransferTimelineCardProps) {
  const advisorName = advisor?.name.trim() ?? '';
  const advisorEmail = advisor?.email.trim() ?? '';
  const canContactAdvisor = advisorName.length > 0 && advisorEmail.length > 0;

  return (
    <div className={cn('rounded-lg bg-background-light p-6', className)}>
      <Text variant={titleVariant} color="dark">
        {title}
      </Text>
      <Stepper
        steps={steps}
        activeStep={activeStep}
        orientation="vertical"
        showIcon={showStepIcons}
        className={cn('mt-3', !showStepIcons && '[&_[data-slot=stepper-connector]]:min-h-14')}
      />

      <div className="mt-6 border-t border-border-light pt-6">
        <Text variant="subtitle-sm" color="dark">
          Questions?
        </Text>
        <Text variant="caption" className="mt-1">
          {canContactAdvisor ? (
            <>
              {advisorName} can help:{' '}
              <a href={`mailto:${advisorEmail}`} className="text-cyan-600 hover:underline">
                {advisorEmail}
              </a>
            </>
          ) : (
            <>
              Our support team can help:{' '}
              <a href="mailto:help@savvywealth.com" className="text-cyan-600 hover:underline">
                help@savvywealth.com
              </a>
            </>
          )}
        </Text>
      </div>
    </div>
  );
}
